import { mutateDocuments } from "@/api/documentFile/useS3Query";
import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/Alert";
import { Box, Button, TextInput } from "@mantine/core";
import {
  S3ApiS3MovePostRequest,
  S3ListGet200ResponseInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

interface RenameFormProps {
  selected: S3ListGet200ResponseInner[];
  refetch: () => void;
}

export const RenameForm = (params: RenameFormProps) => {
  const { selected, refetch } = params;
  const { closeModal } = useModal();

  const [newName, setNewName] = useState("");

  const { mutate: renameMutate } = useMutation(
    (params: S3ApiS3MovePostRequest) => mutateDocuments.move(params).mutationFn(undefined),
    {
      onSuccess: () => {
        customAlert("이름 변경에 성공하였습니다.", "이름 변경", "green");
        closeModal("");
        refetch();
      },
      onError: (error: any) => {
        customAlert(
          error.response?.data?.message ?? "이름 변경에 실패하였습니다.",
          "이름 변경 실패",
          "red",
        );
      },
    },
  );

  return (
    <Box w="24rem">
      <TextInput
        label="이름 변경"
        defaultValue={selected[0].name}
        onChange={(event) => setNewName(event.currentTarget.value)}
      />
      <Button
        mt="md"
        fullWidth
        onClick={async () => {
          if (!newName.trim()) {
            alert("바꾸실 이름을 입력해주세요.");
            return;
          }
          await renameMutate({
            s3MovePostRequest: {
              sourceKey: selected[0].Key ?? "",
              destinationKey: newName ?? "",
            },
          });
          setNewName("");
          refetch();
        }}
      >
        변경
      </Button>
    </Box>
  );
};
